import React from 'react';

import SummaryBlock from './SummaryBlock';

const RenderComponentBasedOnBlock = (props) => {
    const { block } = props

    return (
        <React.Fragment>
            {
                (function () {
                    switch (block.type) {
                        case "summaryItems":
                            return <SummaryBlock key={block.name} {...props} />
                            break;
                        default:
                            return null;
                    }
                })()
            }
        </React.Fragment>
    )
}

export default RenderComponentBasedOnBlock